var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"suitCell"}},[_c('div',{attrs:{"id":"cellDiv"}},[_c('a',{on:{"click":function($event){return _vm.callSuit()}}},[_c('Card',{staticClass:"card",attrs:{"cardId":_vm.cardName,"disabled":_vm.disabled || _vm.clicked}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }